import { SELECTED_CLIENT, CLIENT_LIST } from '../helpers/config'
import cache from '../helpers/cache'

const clientList = [
    {
        value: 'fii',
        label: "FII",
    },
    {
        value: "expo",
        label: "Expo"
    }
]

const initialClient = "fii"

const getClientList = () => {
    let cl = cache.getItem(CLIENT_LIST)
    if (!cl) {
        cl = clientList
        setClientList(cl)
    }
    return cl
}

const setClientList = (cl) => cache.setItem(CLIENT_LIST, cl || clientList)

const getSelectedClient = () => {
    let selectedClient = cache.getItem(SELECTED_CLIENT)
    if (!selectedClient) {
        selectedClient = initialClient
        setSelectedClient(selectedClient)
    }
    return selectedClient
}

const setSelectedClient = (sc) =>
    cache.setItem(SELECTED_CLIENT, sc || initialClient)

const getClientObject = (clientValue) =>
    getClientList().find(c => c.value == clientValue)

const mapClientToSegment = (tableName, selectedClient, expoCountry) => {
    const clientSubstring = selectedClient.includes("expo") ?
        `${selectedClient}${expoCountry}` :
        `${selectedClient}`
    return `${tableName}.${clientSubstring}ClientSegment`
}

export default {
    getClientList,
    setClientList,
    getSelectedClient,
    setSelectedClient,
    getClientObject,
    mapClientToSegment
}